import { createSlice } from '@reduxjs/toolkit';
import axios from '../../services/authService';
import { API_ENDPOINTS } from '../../config/apiConfig';

const initialState = {
  list: [],
  loading: false,
  error: null,
};

const regressionCrudSlice = createSlice({
  name: 'regressionCrud',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setData: (state, action) => {
      state.list = action.payload;
      state.loading = false;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setLoading, setData, setError } = regressionCrudSlice.actions;

/* ===================== API CALLS ===================== */

// GET ALL
export const getAllRegressionTestsAsync = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const res = await axios.get(API_ENDPOINTS.GET_ALL_REGRESSION_TESTS);
    dispatch(setData(res.data?.data || []));
  } catch (err) {
    dispatch(setError(err.message));
  }
};

// CREATE
export const createRegressionTestAsync = (payload) => async () => {
  try {
    const res = await axios.post(API_ENDPOINTS.CREATE_REGRESSION_TEST, payload);

    return {
      success: true,
      data: res.data,
    };
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || err.message || 'Failed to create regression ID',
    };
  }
};

// UPDATE
export const updateRegressionTestAsync = (id, payload) => async () => {
  try {
    const res = await axios.put(`${API_ENDPOINTS.UPDATE_REGRESSION_TEST}?id=${id}`, payload);

    return {
      success: true,
      data: res.data,
    };
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || err.message || 'Failed to update regression ID',
    };
  }
};

// DELETE
export const deleteRegressionTestAsync = (id) => async () => {
  try {
    await axios.delete(`${API_ENDPOINTS.DELETE_REGRESSION_TEST}?id=${id}`);

    return { success: true };
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || err.message || 'Failed to delete regression ID',
    };
  }
};

//GetById
export const getRegressionTestByIdAsync = async (regression_test_id) => {
  try {
    const res = await axios.get(API_ENDPOINTS.GET_ALL_REGRESSION_TESTS, {
      params: { regression_test_id },
    });

    return {
      success: true,
      data: res.data?.data,
    };
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || err.message || 'Failed to fetch regression test',
    };
  }
};

/* ===================== SELECTORS ===================== */

export const selectRegressionList = (state) => state.regressionCrud.list;
export const selectRegressionLoading = (state) => state.regressionCrud.loading;

export default regressionCrudSlice.reducer;
